// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--sy7uQ","title":"a10a3f92e9--title--3mPZV","list":"a10a3f92e9--list--MGGLH"};